import client from "axios";
import store from "../store";
import Vue from "vue";
import VueCookies from "vue-cookies";
import router from "./router";
import enums from "./enums";
import AuthService from "../new/services/AuthService";
import RoutePathEnum from "../enums/RoutePathEnum";

Vue.use(VueCookies);

function handleMessages(response) {
    if (response && response.data && response.data.messages) {
        let messages = response.data.messages ?? [];

        messages.forEach(message => {
            store.commit('app/addAlert', message);
        });
    }
}

client.defaults.withCredentials = true;

client.interceptors.request.use(config => {
    let accessToken = AuthService.getAccessToken();

    if (accessToken !== null) {
        config.headers.Authorization = 'Bearer ' + accessToken;
    }

    return config;
});

client.interceptors.response.use(response => {

    return new Promise(function(resolve) {
        handleMessages(response);
        resolve({data: response.data.data, response: response});
    })
}, error => {

    return new Promise(function (resolve, reject) {
        if (error.response.status === 302) {
            handleMessages(error.response);
            router.push(error.response.data.data);
            reject({data: error.response.data.data, response: error.response});
        }

        if (error.response.status === 503) {
            router.push(enums.RoutePathEnum.MAINTENANCE_MODE_DASHBOARD);
            reject({data: error.response.data.data, response: error.response});
        }

        if (error.response.status === 401) {
            AuthService.revokeAccessToken();
            router.push(RoutePathEnum.LOGIN);
            reject({data: error.response.data.data, response: error.response});
        }

        handleMessages(error.response);
        reject({data: error.response.data.data, response: error.response});
    })

});

export default client;